export default "__VITE_ASSET__30d6c17a__"